<template>
    <div class="bg-b">

        <div class="container">
            <el-row :gutter="20">
                <el-col :sm="{ span: 16, offset: 4 }" :offset="0">
                    <el-card shadow="always" style="margin-top:20px" :body-style="{ padding: '20px' }">
                        <div slot="header">
                            <span>Generar Nueva Contraseña</span>
                        </div>

                        <div class="password-requirements">
                            <h4>La contraseña debe cumplir con los siguientes requisitos:</h4>
                            <ul>
                                <li>
                                    <i :class="['el-icon-' + (formData.password && formData.password.length >= 8 ? 'check' : 'close')]"></i>
                                    Mínimo 8 caracteres
                                </li>
                                <li>
                                    <i :class="['el-icon-' + (formData.password && /[A-Z]/.test(formData.password) ? 'check' : 'close')]"></i>
                                    Al menos una letra mayúscula
                                </li>
                                <li>
                                    <i :class="['el-icon-' + (formData.password && /[0-9]/.test(formData.password) ? 'check' : 'close')]"></i>
                                    Al menos un número
                                </li>
                                <li>
                                    <i :class="['el-icon-' + (formData.password && !isPersonalData(formData.password) ? 'check' : 'close')]"></i>
                                    No puede contener datos personales (DNI, CUIL, teléfono, email)
                                </li>
                            </ul>
                        </div>

                        <el-form ref="form" :model="formData" :rules="rules" v-if="docente"
                            :label-position="$isMobile() ? 'top' : 'left'" label-width="200px" size="normal"
                            style="padding:20px">
                            <el-form-item label="Contraseña" prop="password">
                                <el-input v-model="formData.password" type="password" show-password
                                    autocomplete="off"></el-input>
                            </el-form-item>
                            <br>
                            <el-form-item label="Confirmar Contraseña" prop="confirmPassword">
                                <el-input v-model="formData.confirmPassword" type="password" show-password
                                    autocomplete="off"></el-input>
                            </el-form-item>
                            <br>
                            <el-form-item>
                                <el-button type="primary" :loading="cargando" :disabled="!formValid || cargando" @click="submitForm">Cambiar
                                    contraseña</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                </el-col>
                <el-col :span="12" :offset="0"></el-col>
            </el-row>

        </div>
    </div>
</template>

<script>
import { HTTP } from "@/axios"
export default {
    data() {
        return {
            docente: {},
            cargando: false,
            formValid: false,
            hayDoc:window.sessionStorage.getItem('userData') ? JSON.parse(window.sessionStorage.getItem('userData')) : false,
            formData: {
                password: '',
                confirmPassword: '',

            },
            rules: {
                password: [
                    { required: true, message: 'Por favor, introduzca la contraseña', trigger: 'blur' },
                    { min: 8, message: 'La contraseña debe tener al menos 8 caracteres', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            const tieneLetras = /[a-zA-Z]/.test(value);
                            const tieneNumeros = /[0-9]/.test(value);
                            const tieneMayuscula = /[A-Z]/.test(value);
                            if (!tieneLetras || !tieneNumeros || !tieneMayuscula) {
                                callback(new Error('La contraseña debe contener letras, números y al menos una mayúscula'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    },
                    {
                        validator: (rule, value, callback) => {
                           
                            if (this.isPersonalData(value)) {
                                callback(new Error('La contraseña no puede contener datos personales (CUIL, DNI, etc.)'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                confirmPassword: [
                    { required: true, message: 'Por favor, confirme la contraseña', trigger: 'blur' },
                    { validator: this.validateConfirmPassword, trigger: 'blur' }
                ]
            }
        };
    },
    created(){
        this.getCuitByToken()
    },
    methods: {
        isPersonalData(password) {
            if (!password || !this.docente) return false;
            
            const passwordLower = password.toLowerCase();
            const docente = this.docente;
            
            // Validar CUIL
            if (docente.cuil) {
                const cuilLower = docente.cuil.toLowerCase();
                const cuilSinFormato = cuilLower.replace(/[-\s]/g, '');
                
                // Verificar CUIL completo
                if (passwordLower === cuilLower || passwordLower === cuilSinFormato) {
                    return true;
                }
                
                // Verificar si contiene el CUIL como parte del string
                if (passwordLower.includes(cuilLower) || passwordLower.includes(cuilSinFormato)) {
                    return true;
                }
                
                // Verificar secuencias de 5 o más dígitos del CUIL
                for (let i = 0; i <= cuilSinFormato.length - 5; i++) {
                    const secuencia = cuilSinFormato.substring(i, i + 5);
                    if (passwordLower.includes(secuencia)) {
                        return true;
                    }
                }
            }
            
            // Validar DNI (si existe)
            if (docente.dni) {
                const dni = docente.dni.toString();
                if (passwordLower.includes(dni)) {
                    return true;
                }
            }
            
            // Validar email (si existe)
            if (docente.email) {
                const emailLower = docente.email.toLowerCase();
                if (passwordLower.includes(emailLower)) {
                    return true;
                }
            }
            
            // Validar teléfono (si existe)
            if (docente.telefono) {
                const telefono = docente.telefono.toString().replace(/[-\s]/g, '');
                if (passwordLower.includes(telefono)) {
                    return true;
                }
            }
            
            return false;
        },
        validateConfirmPassword(rule, value, callback) {
            if (value === '') {
                callback(new Error('Por favor, confirme la contraseña'));
            } else if (value !== this.formData.password) {
                callback(new Error('Las contraseñas no coinciden'));
            } else {
                callback();
            }
        },
        getCuitByToken(){
            HTTP.post('/docente/getCuitByToken', {
                docente_id: this.$route.query.c
            })
            .then(res => {
                this.docente = res.data.docente
            })
        },
        submitForm() {
            this.$refs.form.validate(valid => {
                this.formValid = valid;
                if (valid) {
                    // Envía los datos al servidor o realiza otras acciones
                    this.formData.docente_id = this.$route.query.c
                    this.cargando = true
                    setTimeout(() => {

                        HTTP.post('/docente/nuevoPass', this.formData)
                            .then(res => {
                                this.cargando = false
                                if (res.data) {
                                    this.$alert('Contraseña actualizada', {
                                        confirmButtonText: 'Aceptar',
                                        type: 'success',
                                        callback: () => {
                                            this.$router.push({ name: 'docentes' })
                                        }
                                    })

                                }
                                else {
                                    this.$alert('No pudimos actualizar su contraseña, refresque la página y reitente', {
                                        confirmButtonText: 'Aceptar',
                                        type: 'error'

                                    })
                                }

                            })
                            .catch(() => {
                                this.cargando = false
                                this.$alert('No pudimos actualizar su contraseña, refresque la página y reitente', {
                                    confirmButtonText: 'Aceptar',
                                    type: 'error'

                                })
                            })
                    }, 100);
                } else {
                    // Muestra un mensaje de error o toma otras medidas
                    console.log('Datos inválidos. Por favor, revise los campos.');
                }
            });
        }
    },
    watch: {
        'formData.password'() {
            this.$refs.form.validate(valid => {
                this.formValid = valid;
            });
        },
        'formData.confirmPassword'() {
            this.$refs.form.validate(valid => {
                this.formValid = valid;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.password-requirements {
    margin: 20px 0;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border-left: 4px solid #409EFF;

    h4 {
        margin: 0 0 10px 0;
        color: #303133;
        font-size: 14px;
    }

    ul {
        margin: 0;
        padding-left: 20px;
        color: #606266;
        font-size: 13px;

        li {
            margin: 5px 0;
            display: flex;
            align-items: center;
            gap: 8px;

            i {
                font-size: 16px;
                &.el-icon-check {
                    color: #67C23A;
                }
                &.el-icon-close {
                    color: #F56C6C;
                }
            }
        }
    }
}
</style>